export { default as inbox } from "./inbox.svg";
export { default as logo } from "./logo.svg";
export { default as logoText } from "./logo-text.svg";
export { default as google } from "./google.svg";
export { default as whiteCheck } from "./white_check.svg";
export { default as shopify } from "./shopify.svg";
export { default as playGreen } from "./play_green.svg";
export { default as pauseGreen } from "./pause_green.svg";
